import {
    GET_LIST_RELATIONSHIP_TYPES,
    REMOVE_RELATIONSHIP_TYPES,
    GET_RELATIONSHIP_TYPES_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    relationshipTypes: [],
    activeList: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_RELATIONSHIP_TYPES: {
            return {
                ...state,
                relationshipTypes: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_RELATIONSHIP_TYPES_ACTIVE: {
            return {
                ...state,
                activeList: action.payload.data,
            }
        }

        case REMOVE_RELATIONSHIP_TYPES: {
            let temp = state.relationshipTypes.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            let temp2 = state.activeList.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, relationshipTypes: temp, activeList: temp2 }
        }
        default: return { ...state };
    }
}
